import { IHallInfo } from "data/company";
import React from "react";
import styles from "./style.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { black } from "assets/styleUtils";

interface IHall {
  hall: IHallInfo[];
  contructor_no: number;
  setValue?: ({
    contructor_no,
    contructor_hall_no,
  }: {
    contructor_no: number;
    contructor_hall_no?: number;
  }) => void;
}

export default function HallInfo({ hall, contructor_no, setValue }: IHall) {
  return (
    <ul className={styles.list}>
      {(hall || [])?.length > 0 && (
        <ul className={styles.subList}>
          {(hall || []).map((data, j) => {
            const weddingHallInfo = Object.keys(data)
              .map((info) => {
                let filter_key = null;
                let filter_value = null;
                if (info !== null) {
                  switch (info) {
                    case "hall_type":
                      filter_key = "홀타입";
                      filter_value = data[info];
                      break;
                    case "hall_term":
                      filter_key = "예식간격";
                      filter_value = data[info];
                      break;
                    case "hall_max":
                      filter_key = "수용인원";
                      filter_value = data[info];
                      break;
                    case "hall_style":
                      filter_key = "예식스타일";
                      filter_value = data[info];
                      break;
                    case "meal_type":
                      filter_key = "식사스타일";
                      filter_value = data[info];
                      break;
                    case "hall_headcount":
                      filter_key = "홀 착석인원";
                      filter_value = data[info];
                      break;
                    case "min_headcount":
                      filter_key = "최소 보증인원";
                      filter_value = data[info];
                      break;
                    case "max_headcount":
                      filter_key = "최대 수용인원";
                      filter_value = data[info];
                      break;
                  }

                  return {
                    filter_key,
                    filter_value,
                  };
                }
              })
              .filter(Boolean);

            return (
              <li
                key={j}
                onClick={() =>
                  setValue?.({ contructor_no, contructor_hall_no: data.no })
                }
              >
                <div>
                  <h6>{data.hall_name}</h6>
                  <div className={styles.radio}>
                    <input
                      type="checkbox"
                      checked={data.checked}
                      // name={}
                      readOnly
                    />
                    <span />
                  </div>
                </div>

                <>
                  <Swiper
                    spaceBetween={30}
                    className="mySwiper"
                    slidesPerView="auto"
                    threshold={10}
                    pagination={{
                      dynamicBullets: true,
                    }}
                    modules={[Pagination]}
                    centeredSlides={true}
                    style={{
                      backgroundColor: black,
                    }}
                  >
                    {data.photos
                      ?.sort((a, b) => a.ordering - b.ordering)
                      .map((_photo, index) => {
                        return (
                          <SwiperSlide>
                            <img
                              key={index}
                              src={_photo.img_url}
                              style={{
                                height: "280px",
                                width: "100%",
                                objectFit: "contain",
                                backgroundColor: black,
                              }}
                            ></img>
                          </SwiperSlide>
                        );
                      })}
                  </Swiper>
                </>
                <table>
                  <tbody>
                    {weddingHallInfo.map((info, index) => {
                      if (!!info?.filter_value) {
                        return (
                          <tr key={index}>
                            <th>{(info || []).filter_key}</th>
                            <td>{(info || []).filter_value}</td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </li>
            );
          })}
        </ul>
      )}
    </ul>
  );
}
